<template>
  <div class="sale-row sale-header-main">
    <span v-if="cellShow.checkbox" class="cell cell-sticky cell-sticky-first"></span>
    <span v-if="cellShow.number_index" class="cell cell-sticky cell-sticky-second"></span>
    <template v-if="cellShow.trip">
      <span class="cell cell-border-right"></span>
      <span class="cell header-group cell-border-left cell-border-right" style="grid-column: span 2;">Estimasi</span>
      <span class="cell header-group cell-border-left cell-border-right" style="grid-column: span 2;">Nota Armada</span>
    </template>
    <template v-if="cellShow.sale">
      <span class="cell header-group cell-border-left" style="grid-column: span 2;">Nota Bongkar</span>
      <span class="cell" style="grid-column: span 3;"></span>
    </template>
  </div>
</template>

<script>
export default {
  name: "SaleItemGridHeader",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cellShow() {
      if (this.item.trip_item_relation_type === 'merge') {
        return {
          checkbox: true,
          number_index: true,
          trip: true,
          sale: true,
        }
      } else if (this.item.trip_item_relation_type === 'partial') {
        return this.item.is_first_partial_item ? {
          checkbox: true,
          number_index: true,
          trip: true,
          sale: true,
        } : {
          checkbox: false,
          number_index: false,
          trip: false,
          sale: true,
        }
      }
      return {
        checkbox: true,
        number_index: true,
        trip: true,
        sale: true,
      }
    }
  }
};
</script>
